module.exports = __webpack_public_path__ + "static/media/objectives-icon.ebbc870f.svg";